import './style.scss'

import React, { Component } from 'react'

import AddressHelper from 'components/Address/AddressHelper'
import AddressList from 'components/Address/AddressList'
import Form from 'components/UI/Form'
import Spinner from 'components/UI/Spinner'
import { toggleEditAddress } from 'actions/Address'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

class AddressForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            address: null,
            isCheckingAddress: false,
        }
    }
    componentDidUpdate(prevProps) {
        const checkingDone =
            this.state.isCheckingAddress &&
            prevProps.distributionLoading &&
            !this.props.distributionLoading

        if (checkingDone) {
            this.setState({ isCheckingAddress: false })
            this.props.edit && this.props.dispatch(toggleEditAddress(false))
            this.props.canDeliver && this.props.onClose && this.props.onClose()
        }
    }
    componentWillUnmount() {
        this.props.edit && this.props.dispatch(toggleEditAddress(false))
    }
    handleSelected(address) {
        this.props.onSelected && this.props.onSelected(address, true)
    }
    handleStore() {
        const { address } = this.state
        if (!address) return

        this.setState({ address: null, isCheckingAddress: true })
        this.props.onStore && this.props.onStore(address)
        this.props.onSelected && this.props.onSelected(address, false)
    }
    handleAbort() {
        if (this.props.onAbort) {
            this.props.onAbort()
        }
    }
    render() {
        const { edit, isSubscriptionAddress, t } = this.props
        const { isCheckingAddress } = this.state

        if (isCheckingAddress) {
            return (
                <div className="address-form">
                    <Spinner color={'0,0,0'} size="medium" />
                </div>
            )
        }

        return (
            <div className="address-form">
                {!edit && (
                    <div className="address-list-container">
                        <AddressList
                            onSelected={(address) => this.handleSelected(address)}
                            isSubscriptionAddress={isSubscriptionAddress}
                        />
                    </div>
                )}

                {edit && (
                    <Form className="edit-address" onSubmit={() => this.handleStore()}>
                        <AddressHelper
                            onComplete={(address) => {
                                this.setState({ address })
                            }}
                        />
                        <div className="edit-address__buttons">
                            <button
                                type="button"
                                className="edit-address__cancel-btn"
                                onClick={() => this.handleAbort()}
                            >
                                {t('formsAddressFormCancel')}
                            </button>
                            <button type="submit" className="edit-address__save-btn">
                                {t('formsAddressFormSave')}
                            </button>
                        </div>
                    </Form>
                )}
            </div>
        )
    }
}

AddressForm.propTypes = {
    edit: PropTypes.bool,
    isSubscriptionAddress: PropTypes.bool,
    canDeliver: PropTypes.bool,
    distributionLoading: PropTypes.bool,
    onSelected: PropTypes.func,
    onStore: PropTypes.func,
    onClose: PropTypes.func,
    onAbort: PropTypes.func,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

const mapStateToProps = ({ address, distribution }) => {
    return {
        edit: address.edit,
        canDeliver: distribution.canDeliver,
        distributionLoading: distribution.distributionLoading,
    }
}

export default connect(mapStateToProps)(withTranslation()(AddressForm))
